import { Autocomplete, TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import classNames from 'classnames';
import React, { useState, useEffect, useMemo, useCallback } from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { addMaterialItem, updateMaterialItem } from '../../Common/Database';
import { LANGUAGES } from '../../constants/languages';
import {
  getFlagFormAdd,
  setFlagNameAddForm,
  getFlagFormUpdate,
  setFlagNameUpdateForm,
} from '../../redux/slices/flagsSlice';

import './style.scss';

const Modal = ({ open, setOpen, title, submit, nameAction, updateFormObj, materials, mail }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [grade, setGrade] = useState('');
  const [lang, setLang] = useState('');
  const [name, setName] = useState('');
  const [theme, setTheme] = useState('');
  const [fileImg, setFileImg] = useState('');
  const [type, setType] = useState('');
  const [file, setFile] = useState('');
  const [fileError, setFileError] = useState('');
  const [selectedName, setSelectedName] = useState('');
  const flagAddForm = useSelector(getFlagFormAdd);
  const flagUpdateForm = useSelector(getFlagFormUpdate);
  const [flagFile, setFlagFile] = useState(false);
  const [teacherMail, setTeacherMail] = useState(mail);
  const [isFocused, setIsFocused] = useState(false);

  const handleChange = event => {
    setType(event.target.value);
  };

  const validateForm = (grade, lang, name, theme, selectedName, nameAction, file) => {
    console.log('flagUpdateForm', nameAction);
    if (nameAction === 'updateForm') {
      if (grade.length > 0 && lang.length > 0 && name.length > 0 && theme.length > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      if (
        grade.length > 0 &&
        lang.length > 0 &&
        name.length > 0 &&
        theme.length > 0 &&
        selectedName.length > 0 &&
        file !== ''
      ) {
        return true;
      } else {
        return false;
      }
    }
  };

  const unicAutocomplitFunc = (materials, searchItem) => {
    let arr = [];

    materials.forEach(item => {
      switch (searchItem) {
        case 'grade':
          arr.push(item.grade ? item.grade : '-');
          break;
        case 'lang':
          arr.push(item.lang);
          break;
        case 'name':
          arr.push(typeof item.name !== 'number' ? item.name : '-');
          break;
        case 'type':
          arr.push(item.type);
          break;
        case 'subject':
          arr.push(item.subject);
          break;
      }
    });

    const uniqSet = new Set(arr);

    let newArr = [];

    for (let item of uniqSet) {
      newArr.push({ label: item, value: item });
    }

    return newArr;
  };

  const autocompGrade = useMemo(() => {
    return materials ? unicAutocomplitFunc(materials, 'grade') : '';
  }, [materials]);

  const autocompSubject = useMemo(() => {
    return materials ? unicAutocomplitFunc(materials, 'subject') : '';
  }, [materials]);

  useEffect(() => {
    setGrade(updateFormObj ? updateFormObj.grade : '');
    setLang(updateFormObj ? updateFormObj.lang : '');
    setName(updateFormObj ? updateFormObj.name : '');
    setTheme(updateFormObj ? updateFormObj.theme : '');
    setType(updateFormObj ? updateFormObj.type : '');
  }, [updateFormObj]);

  useEffect(() => {
    switch (nameAction) {
      case 'addForm':
        setTeacherMail(mail);
        break;
      case 'updateForm':
        setTeacherMail(updateFormObj.mail);
        break;
    }
  }, [nameAction]);

  const onSubmitFunc = async nameAction => {
    switch (nameAction) {
      case 'addForm':
        await addMaterialItem(selectedName, grade, lang, name, theme, type, file, teacherMail);
        toast.success(t('popupMaterialAdded'));
        break;
      case 'updateForm':
        await updateMaterialItem(
          updateFormObj.subject,
          updateFormObj.id,
          grade,
          lang,
          name,
          theme,
          fileImg,
          type,
          file,
          'updateForm',
          updateFormObj,
          teacherMail,
        );
        toast.success(t('popupMaterialUpdated'));
        break;

      default:
        break;
    }
  };

  const fileHandler = useCallback(
    e => {
      let formatImg = e.target.files[0].name.split('.')[e.target.files[0].name.split('.').length - 1];
      if (formatImg == 'pdf' || formatImg == 'jpg' || formatImg == 'png' || formatImg == 'webp') {
        setFileError('');
        setFile(e.target.files[0]);
        setFlagFile(true);
      } else {
        setFileError(t('wrong file format'));
      }
    },
    [setFileError, setFile, setFlagFile],
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      if (flagAddForm) {
        dispatch(setFlagNameAddForm(false));
        setOpen(false);
      }
      if (flagUpdateForm) {
        dispatch(setFlagNameUpdateForm(false));
        setOpen(false);
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, [flagAddForm, flagUpdateForm]);

  return (
    <div
      className={open ? 'modal-form modal-form--open' : 'modal-form'}
      onClick={e => {
        if (!isFocused) {
          setOpen(false);
        }
        e.stopPropagation();
      }}
    >
      <div
        className="modal-form-content"
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <form>
          <div className="modal-header">
            <h2>{t(title)}</h2>
            <button
              className="btn btn-icon"
              onClick={e => {
                setOpen(false);
                e.preventDefault();
              }}
            >
              <span className="icon icon-plus"></span>
            </button>
          </div>

          <div className="modal-body" id="modal-body">
            <div className="form-control autocomplete-control">
              <Autocomplete
                id="name"
                options={[]}
                value={name}
                onInputChange={(e, v) => setName(v)}
                freeSolo
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('name')}
                    value={name}
                    placeholder=" "
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />
                )}
              />
            </div>

            {nameAction !== 'updateForm' && (
              <div className="form-control autocomplete-control">
                <Autocomplete
                  id="subject"
                  options={autocompSubject}
                  value={selectedName}
                  onInputChange={(e, v) => setSelectedName(v)}
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={t('subject')}
                      placeholder=" "
                      value={selectedName}
                      onFocus={() => setIsFocused(true)}
                      onBlur={() => setIsFocused(false)}
                    />
                  )}
                />
              </div>
            )}
            <div className="form-control autocomplete-control">
              <FormControl className="select-form">
                <InputLabel id="demo-simple-select-label">{t('type')}</InputLabel>
                <Select labelId="demo-simple-select-label" value={type} label={t('type')} onChange={handleChange}>
                  <MenuItem value="Picture">{t('Picture')}</MenuItem>
                  <MenuItem value="Book">{t('Book')}</MenuItem>
                  <MenuItem value="Exam">{t('Exam')}</MenuItem>
                </Select>
              </FormControl>
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="grade"
                options={autocompGrade.sort((a, b) => a.value.localeCompare(b.value, undefined, { numeric: true }))}
                value={grade}
                onInputChange={(e, v) => setGrade(v)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('grade')}
                    value={grade}
                    placeholder=" "
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />
                )}
              />
            </div>

            <div className="form-control autocomplete-control">
              <Autocomplete
                id="lang"
                options={LANGUAGES}
                value={lang}
                onInputChange={(e, v) => setLang(v)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('language')}
                    value={lang}
                    placeholder=" "
                    onFocus={() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                  />
                )}
              />
            </div>

            <div className="form-control material-control">
              <textarea
                name="theme"
                id="theme"
                value={theme}
                placeholder=" "
                onChange={e => setTheme(e.target.value)}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
              ></textarea>
              <label>{t('theme')}</label>
            </div>

            <div className="control-file">
              <label htmlFor="pdf">
                Файл
                {flagFile && <span className="added-file-text">{t('addedFile')}</span>}
                <input id="pdf" type="file" name="pdf" onChange={fileHandler} />
                <span className="btn">{t('chooseFile')}</span>
              </label>
              {fileError && <span className="error">{fileError}</span>}
            </div>
          </div>

          <div className="modal-footer">
            {flagAddForm && <span className="true-form-text">{t('materials added')}</span>}
            {flagUpdateForm && <span className="true-form-text">{t('materialsChanged')}</span>}

            <button
              className={classNames('btn btn-primary more btn-active', {
                disable: !validateForm(grade, lang, name, theme, selectedName, nameAction, file),
              })}
              onClick={e => {
                onSubmitFunc(nameAction);
                e.preventDefault();
              }}
            >
              {t(submit)}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Modal;
